import { common } from '@/common';
import { http } from './fetch';

/**
 * IDE 上的门店 AI 营销入口资格查询。
 * 响应体是 JSON 布尔值，不是 { visible }。
 */
const QUERY_STORE_MARKETING_URL =
  'https://api-cn1.biot-apps.com/v3/eco/model/TNT2310301iifu8z6ymg6tscd812jbxjt7/sunmax_developer_api/queryStoreMarketing/production';

/**
 * 当前身份是否展示门店 AI 营销入口。
 * 同时传递已有的 store_id 与 org_id，也支持只传其中一个。
 * 由接口先检查门店，门店为空或未命中时再检查商户。
 * 两者都空、请求失败或响应不是 true 时不可见。
 */
export async function queryStoreMarketingVisible(): Promise<boolean> {
  const storeId = (common.storeId ?? '').trim();
  const orgId = (common.orgId ?? '').trim();
  if (!storeId && !orgId) return false;

  const body: { store_id?: string; org_id?: string } = {};
  if (storeId) {
    body.store_id = storeId;
  }
  if (orgId) {
    body.org_id = orgId;
  }

  try {
    const visible = await http.post<unknown>(QUERY_STORE_MARKETING_URL, body, {
      timeout: 10000,
    });
    return visible === true;
  } catch {
    return false;
  }
}
